helpPageNextButton = {};

helpPageNextButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);

  button.canEnable = function () {
    return !helpPageManager.pageSwapDisable;
  };

  button.canShow = function () {
    return true;
  };

  button.onPressedCallback = function () {
    helpPageManager.nextPage();
    if (button.soundName !== "") button.playSound();
  };

  return button;
};

helpPageNextButton.initialise = function (json, object) {
  object.soundName = json.soundName || "";
};
helpPageNextButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "helpPageNextButton",
  helpPageNextButton.create,
  helpPageNextButton.initialise,
  helpPageNextButton.getFilesRequired
);
